import { render } from "./ComponentsList.vue?vue&type=template&id=ce23b662"
import script from "./ComponentsList.vue?vue&type=script&lang=js"
export * from "./ComponentsList.vue?vue&type=script&lang=js"

import "./ComponentsList.vue?vue&type=style&index=0&id=ce23b662&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__